import { render, staticRenderFns } from "./tokenizeropts.vue?vue&type=template&id=0eb1cf00&"
import script from "./tokenizeropts.vue?vue&type=script&lang=js&"
export * from "./tokenizeropts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports